import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPlant } from '../api';
import PhotoGallery from '../components/PhotoGallery';
import { categoryLabel } from '../data/categories';
import { categoryTone } from '../data/tones';
import { IconArrowLeft } from '../components/Icons';

export default function PlantDetail({ token }) {
  const { id } = useParams();
  const [plant, setPlant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPlant(id).then(data => { setPlant(data); setLoading(false); });
  }, [id]);

  if (loading) return <p className="empty-state">Loading plant record...</p>;

  if (!plant || plant.error) {
    return (
      <p className="empty-state">
        That plant record could not be found. <Link to="/">Back to all plants</Link>
      </p>
    );
  }

  return (
    <article className="detail">
      <Link to="/" className="back-link"><IconArrowLeft /> All plants</Link>

      <header className="detail__head">
        <span className={`tag ${categoryTone(plant.category)}`}>{categoryLabel(plant.category)}</span>
        <h1 className="detail__title">{plant.plantName}</h1>
        {plant.scientificName && <p className="detail__sci">{plant.scientificName}</p>}
      </header>

      <dl className="facts">
        <div className="facts__item">
          <dt>Category</dt>
          <dd>{categoryLabel(plant.category)}</dd>
        </div>
        <div className="facts__item">
          <dt>Planted</dt>
          <dd>{plant.plantingDate || 'Not recorded'}</dd>
        </div>
        <div className="facts__item">
          <dt>Location in garden</dt>
          <dd>{plant.gardenLocation || 'Not recorded'}</dd>
        </div>
      </dl>

      {plant.careInstructions && (
        <section className="detail__section">
          <h2>Care</h2>
          <p>{plant.careInstructions}</p>
        </section>
      )}

      {plant.growthNotes && (
        <section className="detail__section">
          <h2>Growth notes</h2>
          <p>{plant.growthNotes}</p>
        </section>
      )}

      {token && (
        <Link to={`/admin/plant/${id}/edit`} className="btn btn-secondary">
          Edit this record
        </Link>
      )}

      <PhotoGallery plantId={id} token={token} />
    </article>
  );
}
